import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { errorMessages } from '@assets/data/constants';

@Component({
  selector: 'app-distribute-load-modal',
  templateUrl: './distribute-load-modal.component.html',
  styleUrls: ['./distribute-load-modal.component.less']
})
export class DistributeLoadModalComponent  {

  distributeError: string;
  @Input() testCaseEndPointLoadTestConfigs: any;
  @Output() updatedDistributedLoad: EventEmitter<any> = new EventEmitter();

  constructor(public modal: NgbActiveModal) { }

  

  saveDistributeData(tcEPLoadTestConfigs) {
    this.distributeError = '';
    let total = 0;

    tcEPLoadTestConfigs.forEach(config => {
      if (config.distributedUserLoad > 0) { total += config.distributedUserLoad; }
    });

    if (total > 0 && (total < 100 || total > 100)) {
      this.distributeError = errorMessages.loadDistributeError;
      return;
    } else {
      this.updatedDistributedLoad.emit(tcEPLoadTestConfigs);
      this.modal.close();
    }
  }
}
